import React, { PropTypes } from "react";
import { Link } from "react-router";
import InputField from "components/InputField/InputField.jsx";
import SelectField from "components/InputField/SelectField";
import BranchInput from "containers/Input/BranchInput";
import CountryInput from "containers/Input/CountryInput";
import Radio, { RadioGroup } from "material-ui/Radio";
import { FormControl, FormControlLabel, FormLabel } from "material-ui/Form";

const labels = {
  first_name: "First name",
  last_name: "Last name",
  email: "Email",
  email_confirmation: "Confirm email",
  password: "Password",
  user_type: "I am a",
  imc: "IMC Number",
  registration: "Accreditation Number",
  registration_number: "Registration Number",
  profession: "Profession",
  ipna_member: "IGPNEA member",
  branch: "Branch",
  country: "Country",
  accreditation: "Accreditation",
  company: "Company/Organisation",
  role: "Role",
  reason: "Reason for registration",
  company_name: "Company name",
  position: "Position/role in the company",
};

const roles = [
  { value: "gp", label: "GP" },
  { value: "gp_trainee", label: "GP Trainee" },
  { value: "nurse", label: "Nurse" },
  { value: "consultant", label: "Consultant" },
  { value: "hospital_doctor", label: "NCHD (Hospital Doctor)" },
  { value: "nurse_specialist", label: "Nurse Specialist/ANP" },
  {
    value: "allied_healthcare_professional",
    label: "Allied Healthcare Professional (CORU)",
  },
  { value: "pharmacist", label: "Pharmacy" },
  { value: "industry", label: "Pharmaceutical/Industry Company" },
  { value: "other", label: "Other" },
  // { value: "midwifery", label: "Midwife" },
  // { value: 'practice_nurses_ipna_member', label: 'IGPNEA Members'}
];

const SignUpForm = ({
  user,
  user: {
    first_name,
    last_name,
    email,
    password,
    email_confirmation,
    user_type,
    ipna_member,
    branch,
    country,
    accreditation,
    role,
    company,
    reason,
  },
  onFieldChange,
  onSubmit,
  errors = {},
  termsOfService,
  onTermsOfServiceChange,
  onIpnaChange,
  internationRoleFields,
  irishRoleFields,
  onBranchChange,
  onAccreditaionChange,
  onCountryChange,
  redirectBack,
  isIndustry,
  onIndustryChange,
}) => (
  <div className="container_global_password">
    <h2 className="register_title">CREATE AN ACCOUNT</h2>
    <div className="container_signin row">
      <form className="col s12" onSubmit={onSubmit}>
        <div className="row">
          {[
            {
              field_name: "first_name",
              value: first_name,
            },
            {
              field_name: "last_name",
              value: last_name,
            },
          ].map((e) => (
            <InputField
              className="col s12 m6"
              label={labels[e.field_name]}
              onChange={onFieldChange}
              errors={errors[e.field_name]}
              autoComplete="new-password"
              {...e}
            />
          ))}
          <SelectField
            className="col s12"
            label={labels["user_type"]}
            onChange={onFieldChange}
            errors={errors["user_type"]}
            autoComplete="new-password"
            field_name="user_type"
            value={user_type}
            options={roles}
          />

          {user_type === "other" && (
            <div>
              {[
                {
                  field_name: "email",
                  value: email,
                },
                {
                  field_name: "company",
                  value: company,
                },
                {
                  field_name: "role",
                  value: role,
                },
                {
                  field_name: "reason",
                  value: reason,
                },
              ].map((e) => (
                <InputField
                  className="col s12"
                  label={labels[e.field_name]}
                  onChange={onFieldChange}
                  errors={errors[e.field_name]}
                  autoComplete="new-password"
                  {...e}
                />
              ))}
            </div>
          )}

          {user_type !== "other" && (
            <div>
              <div className="col s12 accreditaion_select">
                <FormControl>
                  <p>Accreditation</p>
                  <RadioGroup
                    //value={webinar.webinar_type}
                    onChange={onAccreditaionChange}
                    value={user.accreditation}
                    row
                  >
                    <FormControlLabel
                      value={true}
                      control={<Radio color="primary" />}
                      label="Irish"
                    />
                    <FormControlLabel
                      value={false}
                      control={<Radio color="primary" />}
                      label="International"
                    />
                  </RadioGroup>
                </FormControl>
              </div>

              {user.user_type === "nurse" ||
              user.user_type === "nurse_specialist" ? (
                <div className="col s12 ipna_select">
                  <FormControl>
                    <p>I am an IGPNEA member</p>
                    <RadioGroup
                      //value={webinar.webinar_type}
                      onChange={onIpnaChange}
                      value={user.ipna_member}
                      row
                    >
                      <FormControlLabel
                        value={true}
                        control={<Radio color="primary" />}
                        label="Yes"
                      />
                      <FormControlLabel
                        value={false}
                        control={<Radio color="primary" />}
                        label="No"
                      />
                    </RadioGroup>
                  </FormControl>
                </div>
              ) : null}

              {user.ipna_member ? (
                <div className="tal">
                  <BranchInput
                    value={branch}
                    onChange={onBranchChange}
                    errors={errors["county"]}
                    className="col s12"
                  />
                </div>
              ) : null}

              {!user.accreditation ? (
                <div className="tal">
                  <CountryInput
                    value={country}
                    onChange={onCountryChange}
                    errors={errors["country"]}
                    className="col s12"
                  />
                </div>
              ) : null}

              {user.accreditation
                ? irishRoleFields.map((field) => (
                    <InputField
                      className="col s12"
                      label={labels[field]}
                      onChange={onFieldChange}
                      errors={errors[field]}
                      autoComplete="new-password"
                      value={user[field] || ""}
                      field_name={field}
                    />
                  ))
                : internationRoleFields.map((field) => (
                    <InputField
                      className="col s12"
                      label={labels[field]}
                      onChange={onFieldChange}
                      errors={errors[field]}
                      autoComplete="new-password"
                      value={user[field] || ""}
                      field_name={field}
                    />
                  ))}

              {[
                {
                  field_name: "email",
                  value: email,
                  type: "email",
                  className: "col s12",
                },
                {
                  field_name: "email_confirmation",
                  value: email_confirmation,
                  type: "email",
                  className: "col s12",
                },
                {
                  field_name: "password",
                  value: password,
                  type: "password",
                  className: "col s12",
                },
              ].map((e) => (
                <InputField
                  className="col s12 m6"
                  label={labels[e.field_name]}
                  onChange={onFieldChange}
                  errors={errors[e.field_name]}
                  autoComplete="new-password"
                  {...e}
                />
              ))}
              <p className="creat_password_text">
                <input
                  type="checkbox"
                  id="checkbox_in"
                  onClick={(e) => onTermsOfServiceChange(e.target.value)}
                  value={termsOfService}
                />
                <label htmlFor="checkbox_in">
                  <Link to={"/terms_of_service"}>
                    I accept the Terms of Service
                  </Link>
                </label>
              </p>
            </div>
          )}

          <div className="submit_center col s12">
            <input
              className="container_password_button"
              type="submit"
              name=""
              value="Sign Up"
            />
          </div>
        </div>
      </form>
      <p className="container_signin_text" style={{ marginBottom: "15px" }}>
        <Link
          to={`/users/sign_in${
            redirectBack ? `?redirectBack=${redirectBack}` : ""
          }`}
        >
          Already have an account?
        </Link>
      </p>
    </div>
  </div>
);

SignUpForm.propTypes = {
  user: PropTypes.object,
  onFieldChange: PropTypes.func,
  onSubmit: PropTypes.func,
  errors: PropTypes.array,
};

export default SignUpForm;



// WEBPACK FOOTER //
// ./src/components/Authorization/SignUp/SignUpForm.js